var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#DC3545"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.875 15.75C34.4844 15.75 35 16.2656 35 16.875C35 17.5312 34.4844 18 33.875 18H33.3125L32.1875 33.2344C32.0469 34.8281 30.7812 36 29.1875 36H19.7656C18.1719 36 16.9062 34.8281 16.7656 33.2344L15.6406 18H15.125C14.4688 18 14 17.5312 14 16.875C14 16.2656 14.4688 15.75 15.125 15.75H18.3594L20.0938 13.1719C20.5625 12.4688 21.4062 12 22.2969 12H26.6562C27.5469 12 28.3906 12.4688 28.8594 13.1719L30.5938 15.75H33.875ZM22.2969 14.25C22.1562 14.25 22.0156 14.3438 21.9688 14.4375L21.0781 15.75H27.875L26.9844 14.4375C26.9375 14.3438 26.7969 14.25 26.6562 14.25H22.2969ZM31.0625 18H17.8906L19.0156 33.0938C19.0625 33.4688 19.3906 33.75 19.7656 33.75H29.1875C29.5625 33.75 29.8906 33.4688 29.9375 33.0938L31.0625 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteMobileIcon);
export default __webpack_public_path__ + "static/media/deleteMobileIcon.d337166d02c2725e11c0258eaa9f97b9.svg";
export { ForwardRef as ReactComponent };